import {PlanActivity} from "lib/scheduler"

export function isOpenPoll(activity: PlanActivity) {
  return typeof activity.content === "string" && activity.content.endsWith("_poll")
}
